import { render, staticRenderFns } from "./ButtonRemoveDocument.vue?vue&type=template&id=716121c7&"
import script from "./ButtonRemoveDocument.vue?vue&type=script&lang=ts&"
export * from "./ButtonRemoveDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports